/* eslint-disable prettier/prettier */
import Axios from "axios";
import {
  TopSheetDownloadURL,
  CenterDescriptiveDownloadURL,
  examWiseDescriptiveRollSheet,
  AttendanceSheetDownloadURL,
  examWiseAttendanceSheet,
  downLoadStudentListApi,
  DownloadPeparwiseListcenter
} from "../../api";
import {
  SET_CENTER_DATA,
  ADD_CENTER_DATA,
  SET_ACTION_PROCESS,
  UNSET_ACTION_PROCESS,
  SET_CENTER_SCHEMA_DATA,
  UNSET_CENTER_SCHEMA_DATA,
} from "../../mutation-types";
import {
  saveMsg,
  updateMsg,
  deleteMsg,
  failedMsg
} from "../../erpUtil";

const state = {};

const getters = {};
const mutations = {};
const actions = {
  downloadPaperWiseCenterReportCsv({ commit }, searchParam) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", {
        color: "primary"
      });
      Axios.get(DownloadPeparwiseListcenter, {
        params: searchParam,
        responseType: "blob", // Set the response type to blob
      }).then((response) => {
        commit("UNSET_LOADING"); // loading Closing
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "Date Weise Examinee_" + searchParam.exam_code + "_" + searchParam.exam_year + "_" + searchParam.center_code + ".xlsx");
        document.body.appendChild(link);
        link.click();
        resolve(response);
      })
        .catch(function (error) {
          commit("UNSET_LOADING"); // loading Closing
          console.log(error);
          reject();
        });
    });
  },
  // downLoadTopSheet({
  //   commit
  // }, searchParam) {
  //   commit("SET_LOADING", {
  //     color: "primary",
  //   });
  //   // script-statement-download
  //   return new Promise((resolve, reject) => {
  //     Axios({
  //       url: TopSheetDownloadURL,
  //       method: "GET",
  //       params: searchParam,
  //     })
  //       .then((response) => {
  //         commit("UNSET_LOADING"); // loading Closing
  //         if (response.data.status === "error") {
  //           console.log("error")
  //           commit("SET_SNACKBAR", {
  //             msg: response.data.message,
  //             color: "red"
  //           });
  //         }
  //         let url = response.data.data;

  //         if (response.data.data.length) {
  //           console.log(url);
  //           // showing on a new tab
  //           var fileLink = document.createElement("a");
  //           fileLink.href = url;
  //           fileLink.setAttribute(
  //             "download",
  //             "downloadStm_" + Date.now() + ".pdf"
  //           );
  //           fileLink.setAttribute("target", "_blank");
  //           document.body.appendChild(fileLink);
  //           fileLink.click();
  //         } else {
  //           console.log("error")
  //           commit("SET_SNACKBAR", {
  //             msg: response.data.message,
  //             color: "red"
  //           });
  //         }

  //       })
  //       .catch(function (error) {
  //         commit("UNSET_LOADING"); // loading Closing
  //         // console.log("I am in error", error);
  //       });
  //   });
  // },

  downLoadTopSheet({ commit }, item) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", {
        color: "primary",
      });

      Axios.get(TopSheetDownloadURL, {
        params: item,
        responseType: "blob",
      })
        .then(function (response) {
          commit("UNSET_LOADING");
          const contentType = response.headers["content-type"];
          if (contentType !== "application/pdf") {
            const reader = new FileReader();
            reader.onload = () => {
              const text = reader.result;
              const parsed = JSON.parse(text);
              commit("SET_SNACKBAR", {
                msg: parsed.message || "Unexpected response",
                color: "red",
              });
              reject();
            };
            reader.readAsText(response.data);
            return;
          }
          resolve(response.data);
        })
        .catch(function (error) {
          commit("UNSET_LOADING");
          commit("SET_SNACKBAR", {
            msg: "Download failed",
            color: "red",
          });
          reject();
        });
    });
  },



  downLoadStudentList({
    commit
  }, searchParam) {
    commit("SET_LOADING", {
      color: "primary",
    });
    // script-statement-download
    return new Promise((resolve, reject) => {
      Axios({
        url: downLoadStudentListApi,
        method: "GET",
        params: searchParam,
      })
        .then((response) => {
          commit("UNSET_LOADING"); // loading Closing
          if (response.data.status === "success") {
            console.log("error")
            commit("SET_SNACKBAR", {
              msg: response.data.message,
              color: "red"
            });
          }
          let url = response.data.data;

          if (response.data.data.length) {
            console.log(url);
            // showing on a new tab
            var fileLink = document.createElement("a");
            fileLink.href = url;
            fileLink.setAttribute(
              "download",
              "downloadStm_" + Date.now() + ".pdf"
            );
            fileLink.setAttribute("target", "_blank");
            document.body.appendChild(fileLink);
            fileLink.click();
          } else {
            console.log("error")
            commit("SET_SNACKBAR", {
              msg: response.data.message,
              color: "red"
            });
          }

        })
        .catch(function (error) {
          commit("UNSET_LOADING"); // loading Closing
          // console.log("I am in error", error);
        });
    });
  },
  downloadRollDescriptiveSheet({
    commit
  }, searchParam) {
    commit("SET_LOADING", {
      color: "primary",
    });
    // script-statement-download
    return new Promise((resolve, reject) => {
      Axios({
        // url: CenterDescriptiveDownloadURL,
        url: examWiseDescriptiveRollSheet,
        method: "GET",
        params: searchParam,
      })
        .then((response) => {
          commit("UNSET_LOADING"); // loading Closing
          let url = response.data.data;
          if (url == null) {
            return this.url = response.data.message
          }

          // showing on a new tab
          var fileLink = document.createElement("a");
          fileLink.href = url;
          fileLink.setAttribute(
            "download",
            "downloadStm_" + Date.now() + ".pdf"
          );
          fileLink.setAttribute("target", "_blank");
          document.body.appendChild(fileLink);
          fileLink.click();
        })
        .catch(function (error) {
          commit("UNSET_LOADING"); // loading Closing
          // console.log("I am in error", error);
        });
    });
  },



  downloadAttendanceSheet({
    commit
  }, searchParam) {
    console.log(searchParam);
    commit("SET_LOADING", {
      color: "primary",
    });
    // script-statement-download
    return new Promise((resolve, reject) => {
      Axios({
        // url: AttendanceSheetDownloadURL,
        url: examWiseAttendanceSheet,
        method: "GET",
        params: searchParam,
      })
        .then((response) => {
          commit("UNSET_LOADING"); // loading Closing
          let url = response.data.data;
          console.log(url);

          // showing on a new tab
          var fileLink = document.createElement("a");
          fileLink.href = url;
          fileLink.setAttribute(
            "download",
            "downloadStm_" + Date.now() + ".pdf"
          );
          fileLink.setAttribute("target", "_blank");
          document.body.appendChild(fileLink);
          fileLink.click();
        })
        .catch(function (error) {
          commit("UNSET_LOADING"); // loading Closing
          // console.log("I am in error", error);
        });
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};